<template>
  <abw :permissions="getComponentPermissions"></abw>
</template>

<script>
import abw from "@/components/culture/abw";
import { permissionsToStringMap as permissions } from "@/middleware/pageAccessManager";
export default {
  components: { abw },
  computed: {
    getComponentPermissions() {
      return {
        keyToValidateAccess: "PERMISSIONS",
        PERMISSIONS: [permissions.MANAGE_ABW],
      };
    },
  },
};
</script>

<style></style>
